import React from 'react';
import { CoinsIcon, CompassIcon, GiftIcon, LibraryBigIcon, ShieldIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: LibraryBigIcon,
  title: '4 Tomos de Sabiduría Aplicada',
  description: '130+ mapas sobre decisiones, dinero, vínculos, familia, ansiedad y propósito.'
}, {
  icon: CompassIcon,
  title: '50 Mapas para Decidir con Claridad',
  description: 'Prudencia, riesgos, planificación y consejo sabio para consultar cuando no sabés qué hacer.'
}, {
  icon: CoinsIcon,
  title: '30 Mapas de Dinero y Prosperidad',
  description: 'Deudas, trabajo, ahorro, generosidad y principios para relacionarte mejor con el dinero.'
}, {
  icon: UsersIcon,
  title: '30 Mapas de Vínculos y Familia',
  description: 'Comunicación, conflictos, pareja e hijos para hablar con sabiduría sin destruir vínculos.'
}, {
  icon: ShieldIcon,
  title: '25 Mapas de Ansiedad y Propósito',
  description: 'Principios de Eclesiastés para atravesar el estrés, aceptar los tiempos y recuperar perspectiva.'
}, {
  icon: GiftIcon,
  title: '6 Herramientas Extra Incluidas',
  description: 'Índice SOS, Plan de 7 Días, Oraciones, Kit Familiar, Scripts de Conversación y Tracker de Decisiones.'
}];
export function PackageContents() {
  return <section className="w-full bg-cream py-16 md:py-24" data-id="element-98" data-mp="3714r0wc022ge">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-99" data-mp="3bx39k3ancq8w">
        <header className="mx-auto max-w-narrow text-center" data-id="element-100" data-mp="3fzq96qdk7fgn">
          <h2 className="font-display text-[2rem] font-extrabold leading-[1.12] tracking-tight text-ink md:text-5xl" data-id="element-101" data-mp="3fxwy8yvwy92u">
            Todo lo que recibís dentro de la Biblioteca
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-gray-500 md:text-xl" data-id="element-102" data-mp="3pxe2dbvioewp">
            Un sistema de sabiduría visual para las decisiones, el dinero, los vínculos y los
            momentos en que necesitás recuperar claridad.
          </p>
        </header>

        <ul className="mt-12 grid gap-5 md:mt-16 md:grid-cols-2 lg:grid-cols-3" data-id="element-103" data-mp="1ninoevui9q7l">
          {items.map(item => <li key={item.title} className="flex h-full flex-col items-center rounded-2xl bg-canvas px-7 py-9 text-center" data-id="element-104" data-mp="1jin793g0v0wu">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-forest-100 text-forest-600" data-id="element-105" data-mp="1sijqgpjn77ki">
                <item.icon className="h-6 w-6" aria-hidden="true" data-id="element-106" data-mp="26h9llzmwix68" />
              </span>
              <h3 className="mt-5 font-display text-lg font-extrabold leading-snug tracking-tight text-ink" data-id="element-107" data-mp="22gzhytml0iuj">
                {item.title}
              </h3>
              <p className="mt-3 leading-relaxed text-gray-500" data-id="element-108" data-mp="2g9ywasamo70i">{item.description}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}